import './Creator.css';

const socialLinks = [
  ['Instagram', 'https://instagram.com/nechecode/'],
  ['LinkedIn', 'https://www.linkedin.com/in/nechecode/'],
  ['TikTok', 'https://www.tiktok.com/@nechecode'],
  ['Telegram', 'https://t.me/nechecode'],
  ['X', 'https://x.com/nechecode'],
  ['Threads', 'https://www.threads.com/@nechecode'],
  ['YouTube', 'https://www.youtube.com/@nechecode'],
];

function OutwardArrow() {
  return <span className="creator-arrow" aria-hidden="true">↗</span>;
}

export default function Creator() {
  return <div className="creator-page">
    <a className="skip-link" href="#creator-content">Skip to content</a>
    <header className="creator-header creator-container">
      <a className="creator-wordmark" href="/" title="Aurelia House home">AURELIA{' '}<span>HOUSE</span></a>
      <a className="creator-back" href="/"><span aria-hidden="true">←</span> Back to the residence</a>
    </header>

    <main id="creator-content" className="creator-container" tabIndex={-1}>
      <p id="creator-new-tab-note" className="sr-only">Opens in a new tab.</p>
      <section className="creator-intro" aria-labelledby="creator-title">
        <p className="creator-eyebrow">Behind the experience</p>
        <h1 id="creator-title">Designed and built<br />by <em>NecheCode.</em></h1>
        <div className="creator-intro-bottom">
          <p className="creator-handle">@nechecode</p>
          <p className="creator-invitation">For enquiries, collaborations,<br />or simply to say hello.</p>
        </div>
      </section>

      <section className="creator-section" aria-labelledby="creator-contact-title">
        <div className="creator-section-label"><span aria-hidden="true">01</span><h2 id="creator-contact-title">Let’s connect.</h2></div>
        <div className="creator-contact-links">
          <a href="https://www.nechecode.com" target="_blank" rel="noopener noreferrer" aria-labelledby="creator-website-label" aria-describedby="creator-new-tab-note">
            <span className="creator-link-body" id="creator-website-label"><span className="creator-eyebrow">Website</span>{' '}<span className="creator-contact-value">www.nechecode.com</span></span>
            <OutwardArrow />
          </a>
          <a href="mailto:victor@nechecode.com" aria-labelledby="creator-email-label">
            <span className="creator-link-body" id="creator-email-label"><span className="creator-eyebrow">Email</span>{' '}<span className="creator-contact-value">victor@nechecode.com</span></span>
            <OutwardArrow />
          </a>
        </div>
      </section>

      <section className="creator-section creator-social-section" aria-labelledby="creator-social-title">
        <div className="creator-section-label"><span aria-hidden="true">02</span><h2 id="creator-social-title">Elsewhere.</h2></div>
        <div>
          <p className="creator-social-intro">One handle. Find me on your favourite platform.</p>
          <ul className="creator-social-links">
            {socialLinks.map(([platform, url]) => <li key={platform}>
              <a href={url} target="_blank" rel="noopener noreferrer" aria-labelledby={`creator-social-${platform.toLowerCase()}`} aria-describedby="creator-new-tab-note">
                <span className="creator-social-text" id={`creator-social-${platform.toLowerCase()}`}><span className="creator-platform">{platform}</span>{' '}<span className="creator-social-handle">@nechecode</span></span>
                <OutwardArrow />
              </a>
            </li>)}
          </ul>
        </div>
      </section>
    </main>

    <footer className="creator-footer creator-container">
      <span>NecheCode <span aria-hidden="true">©</span> {new Date().getFullYear()}</span>
      <span>Design & development credit for Aurelia House</span>
      <a href="/">Return to Aurelia <span aria-hidden="true">↗</span></a>
    </footer>
  </div>;
}
